import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import moment from 'moment';
import allowedTimeRangeMixins from './allowedTimeRangeMixins';
export default {
  name: 'CoreDateTimePickerField',
  mixins: [allowedTimeRangeMixins],
  props: {
    label: {
      type: String,
      required: true,
      default: ''
    },
    value: {
      type: String,
      required: true
    },
    dateValue: {
      type: Number,
      required: true
    },
    rules: {
      type: Array,
      required: true
    },
    firstDayOfWeek: {
      type: String,
      required: false,
      default: '1'
    }
  },
  data: function data() {
    return {
      pickerDate: null,
      showPickerDialog: false
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])),
  watch: {
    dateValue: function dateValue() {
      this.setupPickerDate();
    }
  },
  created: function created() {
    this.setupPickerDate();
  },
  methods: {
    setupPickerDate: function setupPickerDate() {
      if (new Date(this.dateValue).toString() !== 'Invalid Date') {
        this.pickerDate = moment(new Date(this.dateValue * 1000)).format('YYYY-MM-DD');
      } else {
        this.pickerDate = moment(new Date()).format('YYYY-MM-DD');
      }
    },
    handleDateSelected: function handleDateSelected(isoDateString) {
      this.$emit('date:picked', isoDateString);
    },
    handleDateChanged: function handleDateChanged(value) {
      this.$emit('date:changed', value);
    }
  }
};